export function makeCompositionItems(data) {
    const composition = data?.garrison?.compositions ?? [];

    return composition.flatMap((composition, index) => [
        {
            label: `Guarnição`,
            value: composition?.name ?? "",
        },
        {
            label: `Contingentes`,
            value: composition?.integrants ?? "",
        }
    ])
}